/**
 * CSRF token helpers.
 *
 * Django's session/cookie-based CSRF protection requires every mutating
 * request (POST / PUT / PATCH / DELETE) to carry the token value from the
 * `csrftoken` cookie in an `X-CSRFToken` request header.
 *
 * This module reads the token from `document.cookie` so `baseQuery` can
 * inject it into every outgoing request.
 */

/**
 * Reads the `csrftoken` cookie and returns its decoded value, or `null` when
 * the cookie is absent (e.g. first load before Django sets it).
 */
export function getCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;

  const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  if (!match) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    // If the cookie value is malformed, return it raw rather than throwing.
    return match[1];
  }
}
